import { DomainVO } from '../../vo/core/domain.vo';
import { VisionScenario, VisionCriteria, VisionWrapper, Vision } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { VISION_PROPERTY } from '../../model/enums';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD, WIZ_COMMAND_STATE } from '@wizeoo/akm-core-lib';
import { BusinessUnitVO } from '../../vo/core/business-unit.vo';
import { ViewData } from '../../model/view.data';
import { UserApplicationVO } from '../../vo/user/user-app.vo';
import { StaticFeatureEnum } from '../../manager/permission/permissions.types';
/** chargement de l'ensemble des visions de la BU, sans les steps */
export class FindVisionCommand extends WizCommand<VisionWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  /**
   * La cible de la commande, les visions BU ou all (ou dom, comme all mais traitement différent sur result) ?
   */
  target: 'bu' | 'all' | 'dom';

  /**
   * Le résultat du chargement des visions seulement en mode all
   */
  visions: VisionVO[];

  /**
   * Recherche des visions du domain pour le user connecté
   */
  find(pCallback?: (cmd: FindVisionCommand) => void): FindVisionCommand {
    const wrapper: VisionWrapper = new VisionWrapper();
    wrapper.scenario = new VisionScenario();
    wrapper.scenario.manageKeys = true;
    wrapper.scenario.manageSteps = true;
    wrapper.scenario.manageMeasures = true;
    wrapper.criteria = new VisionCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.target = 'bu';
    super.configureRemote(
      ExternalAPI.VISION_API,
      wrapper,
      pCallback
    );

    return this;
  }

  /** construction du wrapper pour recherche de toutes les visions du user (menu.akm & Dom) */
  private allVisionWrapper(): VisionWrapper {
    const wrapper: VisionWrapper = new VisionWrapper();
    wrapper.scenario = new VisionScenario();
    wrapper.criteria = new VisionCriteria();
    const doms: DomainVO[] = this.model.connectedUser.allDomains;
    if (doms) {
      wrapper.criteria.domainList = doms.map(item => item.code);
    } else {
      wrapper.criteria.domain = this.model.currentDomainCode;
    }
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    return wrapper;
  }

  /**
   * Recherche de toutes les visions pour akDom
   */
  findForDom(pCallback?: (cmd: FindVisionCommand) => void): FindVisionCommand {
    const wrapper: VisionWrapper = this.allVisionWrapper();
    this.target = 'dom';
    super.configureRemote(
      ExternalAPI.VISION_API,
      wrapper,
      pCallback
    );

    return this;
  }

  wizResult() {
    super.wizResult();

    if (this.state === WIZ_COMMAND_STATE.SUCCESS) {
      
      if (this.result?.entities) {
        // console.log('vision loaded');
        let vos: VisionVO[] = [];
        this.result.entities.forEach((v: Vision) => {
          const vo: VisionVO = this.model.visionEngine.newVisionVO(v);
          this.model.syncService.checkLocal(null, vo);
          vos.push(vo);
        })
        if (this.target === 'dom') { // chargement global pour DOM
          const bus = this.model.businessUnitList;   
          const visionAndBus: VisionVO[] = []; // visions + accès BU.*
    
          if (!!bus) {
            bus.forEach((bu: BusinessUnitVO) => { // ajout des accès BUs
              const vis: VisionVO = new VisionVO();
              vis.domain = bu.domain;
              vis.businessUnitCode = bu.businessUnitCode;
              vis.code = ViewData.wildcardDomain;
    
              const uappVO: UserApplicationVO = new UserApplicationVO(this.model);
              uappVO.domain = vis.domain;
              uappVO.businessUnitCode = vis.businessUnitCode;
              uappVO.visionCode = vis.code;
              if (this.model.permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, uappVO)) {
                visionAndBus.push(vis);
              } else {
                console.log('vision Cmd no permisson', uappVO);
              }
            })
          } else {
            console.log('vision Cmd no BU');
          }
    
          if (!!vos) {
            vos.forEach((vis: VisionVO) => {
              const uappVO: UserApplicationVO = new UserApplicationVO(this.model);
              uappVO.domain = vis.domain;
              uappVO.businessUnitCode = vis.businessUnitCode;
              uappVO.visionCode = vis.code;
              if (this.model.permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, uappVO)) {
                visionAndBus.push(vis);
              }
            });
          }

          this.model.visions = visionAndBus;

        } else if (this.target === 'bu') {
          vos.forEach((vo: VisionVO) => {
            this.model.syncService.checkLocal(null, vo);
            this.model.visionEngine.setVisionProperties(vo, VISION_PROPERTY.LOADED, true);
          })
          this.model.visionEngine.feedVisions(vos);
        } else { // recherche de toutes les visions pour akm.menu.pop
          this.visions = vos;
        }
      } else {
        console.log('no visions');
      }

    }
  }

}
